import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-16 md:py-20 px-4" data-id="element-91" data-mp="4vrzlvp3q9pt">
      <div className="max-w-4xl mx-auto" data-id="element-92" data-mp="9umkd36mq8ck">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 shadow-sm text-center" data-id="element-93" data-mp="9srwbg02a049">
          <div className="w-20 h-20 rounded-full bg-rose/10 flex items-center justify-center mx-auto mb-6" data-id="element-94" data-mp="slmcgd9f7ya2">
            <ShieldCheckIcon className="w-9 h-9 text-rose" data-id="element-95" data-mp="xm1nuza56vpe" />
          </div>
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-5" data-id="element-96" data-mp="12kbnbm2wgigt">
            <span className="text-xs font-bold tracking-widest" data-id="element-97" data-mp="17id2hvx7fxn0">
              🛡️ GARANTÍA 7 DÍAS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl md:text-4xl text-ink uppercase tracking-tight" data-id="element-98" data-mp="20su4t51kers2">
            Probalo{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-99" data-mp="1vszdx1hsi270">
              sin riesgo
            </span>
          </h2>
          <p className="text-ink-soft text-base md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed" data-id="element-100" data-mp="1rtyw9mb1t5ll">
            Abrís el Kit. Explorás los materiales. Probás las herramientas.
          </p>
          <p className="text-ink-soft text-base md:text-lg mt-3 max-w-2xl mx-auto leading-relaxed" data-id="element-101" data-mp="2jjvbygcu9tmp">
            Si dentro de los 7 días no es lo que esperabas, solicitás la
            devolución y recuperás el{' '}
            <strong className="text-ink" data-id="element-102" data-mp="2aoxf4y6klwq3">100% de tu dinero</strong>.
          </p>
        </motion.div>
      </div>
    </section>;
}